import global from "../global.js";
import {escape_html} from "../utils/Escape.js";

const log = global.log.getLogger("f_mtac.ui.RoomListArea");
log.setLevel(log.levels.WARN);

let RoomListArea = function RoomListArea() {
    var {Modal} = window.f_mtac_theme;
    var room_list_area_modal;
    let $room_list_area = document.getElementById("room_list_area");

    let refreshSelection = (selected_space_index) => {
        $("#room_list_area .mission-item.selected").removeClass("selected");
        if (selected_space_index !== undefined) {
            $("#room_list_area .mission-item").eq(selected_space_index).addClass("selected");
        }
    };
    let refreshSpaceStatus = async (space_index) => {
        let $space_btn = $("#room_list_area button.mission-item[data-space-index='" + space_index + "']");
        let space = await global.storage.open_space({space_index});
        var space_is_empty = (await space.is_empty()) ? true : null;
        $("#room_list_area .mission-item").eq(space_index).find("[data-method='duplicate']").attr("disabled", space_is_empty);
        $("#room_list_area .mission-item").eq(space_index).find("[data-method='erase']").attr("disabled", space_is_empty);
        if (space_is_empty && (space.name === "" || space.name === global.internationalization.text("global.Without-name"))) {
            // AGPOC-3481 : if space name not empty, display space name and creation date
            $space_btn.html(global.internationalization.text("archive.Empty"));
        } else {
            let space_name = space.name !== "" ? space.name : global.internationalization.text("global.Without-name");
            // let space_created = new Date(space.created);
            // let space_modified = new Date(space.modified);
            $space_btn.html(
                `<span>${escape_html(space_name)}</span>`
                // <h6>${global.internationalization.text("archive.Created")}<br>${global.internationalization.formatDate(space_created)}&nbsp${global.internationalization.formatTime(space_created)}</h6>
                // <h6>${global.internationalization.text("archive.Modified")}<br>${global.internationalization.formatDate(space_modified)}&nbsp${global.internationalization.formatTime(space_modified)}</h6>
            );
        }
    };
    let refreshAllSpaceStatus = () => {
        $("#room_list_area button.mission-item").each(async function () {
            refreshSpaceStatus($(this).data("space-index"));
        });
    };

    this.interact = function ({title, selected_space, selected_disable, ask_confirmation}) {
        let space_index = null;
        let confirm_selection = false;
        let options = selected_space == undefined ? {backdrop: "static", keyboard: false} : undefined;
        room_list_area_modal = new Modal($room_list_area, options);
        $("#room_list_area .modal-title").text(title);
        refreshAllSpaceStatus();
        refreshSelection();
        if (selected_space !== undefined && selected_disable === true) {
            $("#room_list_area button.mission-item").removeAttr("disabled");
            $("#room_list_area button.mission-item").eq(selected_space).attr("disabled", true);
        }
        if (ask_confirmation) {
            var commands = {
                cancel: $("#room_list_area .modal-header").children().first(),
                confirm: $("#room_list_area .modal-header").children().last()
            };
            commands.cancel.find("button").removeAttr("disabled");
            commands.cancel.show();
            commands.confirm.find("button").attr("disabled", true);
            commands.confirm.show();
        }

        // User actions handlers
        var handlers = {
            open: ($btn) => {
                space_index = $btn.data("space-index");
                refreshSelection(space_index);
                if (ask_confirmation) {
                    commands.confirm.find("button").removeAttr("disabled");
                } else {
                    confirm_selection = true;
                    room_list_area_modal.hide();
                }
            },
            ok: () => {
                space_index = $("#room_list_area button.selected").data("space-index");
                confirm_selection = true;
                room_list_area_modal.hide();
            },
            cancel: () => {
                room_list_area_modal.hide();
            }
        };

        $("body").on("click.room_list_area.btn", "#room_list_area .btn", (event) => {
            let $btn = $(event.currentTarget);
            handlers[$btn.data("method")]($btn);
        });

        return new Promise((resolve) => {
            let interaction_end = () => {
                $room_list_area.removeEventListener("hidden.bs.modal", interaction_end);
                $("body").off("click.room_list_area.btn", "#room_list_area .btn");
                if (confirm_selection === true) {
                    resolve(space_index);
                }
                resolve(null);
            };
            $room_list_area.addEventListener("hidden.bs.modal", interaction_end);
            room_list_area_modal.show();
            $("#splash").hide();
        });
    };
};
export default new RoomListArea();
